import {merchantLocalStorage} from "../modules/merchant-state/MerchantStorage.js";
import {MERCHANT_STORAGE_KEYS} from "../Constants.js";
import {Dispatcher} from "../../stem-core/base/Dispatcher";
import {isString} from "../../stem-core/base/Utils.js";


const PAGE_VISITS_MAX_ENTRIES = 50;
let lastPageAccessed: string | null = null;
const pageAccessDispatcher = new Dispatcher();

export function normalizePath(url: string | URL) {
    if (isString(url)) {
        url = new URL(url, self.location.href);
    }
    // TODO This is from Darius, why do we care about normalizetion
    return url.pathname + (url.pathname.endsWith("/") ? "" : "/");
}

export function isPathEqual(a: string | URL, b: string | URL) {
    return normalizePath(a) === normalizePath(b);
}

interface PageVisitRecord {
    firstVisit: number;
    lastVisit: number;
    [key: string]: any;
}

export function loadPageVisitsMap(): Map<string, PageVisitRecord> {
    const initialState = merchantLocalStorage.getItem(MERCHANT_STORAGE_KEYS.pageVisits);
    return new Map(initialState?.v || []);
}

export function updatePageVisit(url: string | URL, metadata: Record<string, any>): [PageVisitRecord, Map<string, PageVisitRecord>] {
    let pageVisitsMap = loadPageVisitsMap();
    const path = normalizePath(url);

    const now = Date.now();
    const currentVisit = {
        firstVisit: now, // To be overwritten if exists
        ...pageVisitsMap.get(path),
        ...metadata,
        lastVisit: now,
    };

    // Add to the set and maybe clean it if there are too many entries
    pageVisitsMap.set(path, currentVisit);

    // Truncate if there are too many.
    if (pageVisitsMap.size > PAGE_VISITS_MAX_ENTRIES) {
        const newEntries = [...pageVisitsMap]
            .sort((a, b) => b[1].lastVisit - a[1].lastVisit) // sort descending by timestamp
            .slice(0, PAGE_VISITS_MAX_ENTRIES); // keep the most recent

        pageVisitsMap = new Map(newEntries);
    }
    merchantLocalStorage.setItem(MERCHANT_STORAGE_KEYS.pageVisits, {
        v: [...pageVisitsMap],
    });
    return [currentVisit, pageVisitsMap];
}

export function isURLViewed(url: string) {
    const visitedPages = [
        location.pathname,
        ...loadPageVisitsMap().keys()
    ]

    for (const visitedPath of visitedPages) {
        if (isPathEqual(url, visitedPath)) {
            return true;
        }
    }
    return false;
}

// Will immediately call the function with the current URL
export function onCurrentAndFuturePageAccess(callback: (url: string | null) => void) {
    if (pageAccessDispatcher.listeners.length === 0) {
        lastPageAccessed = self.location.href;
        setInterval(() => {
            const currentUrl = self.location.href;
            if (currentUrl !== lastPageAccessed) {
                lastPageAccessed = currentUrl;
                pageAccessDispatcher.dispatch(currentUrl);
            }
        }, 200);
    }
    callback(lastPageAccessed);
    return pageAccessDispatcher.addListener(callback);
}

export function dispatchPageAccess(url: string) {
    pageAccessDispatcher.dispatch(url);
}

export function markURLVisited(url: string, metadata?: Record<string, any>) {
    updatePageVisit(url, metadata);
    dispatchPageAccess(url);
}
